import React from "react";
import { graphql } from "gatsby"
import { Helmet } from "react-helmet";
import Img from "gatsby-image"
import Markdown from "../../components/Markdown"
import * as PropTypes from "prop-types"

import style from "./index.module.css";
import page from "../../config/global-styles/content.module.css";

const propTypes = {
  data: PropTypes.object.isRequired,
}

class Event extends React.Component {
  render() {
    const event = this.props.data.event
    return (
      <div>
        <Helmet>
          <title>Event: {event.name}</title>
        </Helmet>
        <div>
          <div className={style.imageContainer}>
            <Img className={style.image} fluid={event.image.fluid} />
          </div>

          <div className={page.content}>
            <div className={page.text}>
              <h1>{event.name}</h1>
              {/*event.startDate &&
                <div>{event.startDate}</div>
              */}
              {event.description &&
                <Markdown source={event.description.description} softBreak="br" className="text" />
              }
            </div>
          </div>

          <div className={style.gallery}>
            {event.gallery && event.gallery.map((image, index) => {
              if (image) {
                return (
                  <div className={style.galleryContainer} key={index}>
                    <Img className={style.galleryImage} fluid={image.fluid} alt={image.title} title={image.title} />
                  </div>
                )
              } else {
                return false
              }
            })}
          </div>
        </div>
      </div>
    )
  }
}

Event.propTypes = propTypes

export default Event

export const pageQuery = graphql`
  query($slug: String) {
    event: contentfulEvent(slug: { eq: $slug }) {
      name
      slug
      startDate(formatString: "D MMMM YYYY" locale: "nl")
      endDate(formatString: "D MMMM YYYY" locale: "nl")
      image {
        fluid(maxWidth: 2500) {
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
          aspectRatio
        }
      }
      description {description}
      gallery {
        title
        description
        fluid(maxWidth: 2500, quality: 80) {
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
          aspectRatio
        }
      }
    }
  }
`